module.exports = __webpack_public_path__ + "media/images/illustration_11-08a04909b07f0b3bb27e41102cd7459f.png";